import React from 'react';
import { colors } from 'styleguide';

interface LeftProps {
  width?: number;
  height?: number;
  color?: {
    primrary: string;
    secondary: string;
  };
}

const Left = ({
  width = 64,
  color = { primrary: '#9498A7', secondary: colors('neutral', 3) },
}: LeftProps) => (
  <svg width={width} viewBox="0 0 64 42" fill="none">
    <rect
      x="48.5"
      y="0.5"
      width="15"
      height="23"
      rx="1.5"
      stroke={color.primrary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="48.5"
      y="28.5"
      width="15"
      height="13"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="0.5"
      y="0.5"
      width="43"
      height="23"
      rx="1.5"
      stroke={color.primrary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="0.5"
      y="28.5"
      width="43"
      height="13"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
  </svg>
);

export default Left;
